import './App.css';
import RouteContainer from './routeContainer/RouteContainer';

function App() {
  return (
    <div className="App">
      <RouteContainer/>
    </div>
  );
}

export default App;
